import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { IoIosCloseCircle } from 'react-icons/io';
interface ActionSheetProps extends PropsWithChildren {
  open: boolean;
  setOpen: (val: boolean) => void;
  children?: React.ReactNode;
  title?: string;
  canCloseOutside?: boolean
}
export default function Action({
  open,
  setOpen,
  children,
  title,
  canCloseOutside = true
}: ActionSheetProps) {
  return (
    <div
      className={classNames('fixed z-[100] h-screen w-screen top-0 duration-300', {
        'opacity-0 invisible': !open,
        'opacity-100 visible': open,
      })}>
      <div
        className="w-full h-full sticky z-[-10] bg-black/80 transition-all duration-300 ease-in-out"
        onClick={() => {
          if(canCloseOutside) setOpen(!open);
        }}></div>
      <div
        className={classNames(
          'bg-white min-w-full h-[60%] absolute z-0 bottom-0 duration-300 rounded-t-lg overflow-hidden ',
          {
            'translate-y-0': open,
            'translate-y-full': !open,
          },
        )}>
        <div className='h-full w-full'>
          <div className="flex flex-row items-center justify-between py-2.5 px-3.5">
            <p className="font-bold text-base m-0">{title}</p>
            <div className="" onClick={() => setOpen(false)}>
              <IoIosCloseCircle size={24} />
            </div>
          </div>
          <div className="w-full h-[1px] bg-shadow-3" />
          {children}
        </div>
      </div>
    </div>
  );
}
